var map = {
	"./beginningteacherswebinar.json": [
		1277,
		157
	],
	"./brain-breaks.json": [
		1278,
		158
	],
	"./classroomsetupwebinar.json": [
		1279,
		159
	],
	"./exploretswebinar.json": [
		1280,
		160
	],
	"./first-nations-perspectives.json": [
		1281,
		161
	],
	"./gamified-learning.json": [
		1282,
		162
	],
	"./handwriting.json": [
		1283,
		163
	],
	"./know-your-country.json": [
		1284,
		164
	],
	"./teacher-wellbeing.json": [
		1285,
		165
	],
	"./udl.json": [
		1286,
		166
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1234;
module.exports = webpackAsyncContext;